import { ApexGrid } from './components/grid.js';

export { ApexGrid };

ApexGrid.register();
